import { App } from '@capacitor/app'

import { isNative } from './platform'

let cached: Promise<string | null> | null = null

/**
 * Versión de la app de tienda (`1.0.7`) para el header `X-App-Version`: con ella el backend
 * aplica la versión mínima y mide qué versiones siguen en uso (spec
 * `2026-10-17-version-minima-app`). `null` en web. Se pide una vez y se reutiliza.
 *
 * Si el plugin falla, `null`: sin header la petición pasa igual (el servidor nunca bloquea por
 * un dato que no tiene), así que un fallo aquí no deja la app sin servicio.
 */
export function appVersion(): Promise<string | null> {
  if (!isNative()) return Promise.resolve(null)
  cached ??= App.getInfo().then(
    (info) => info.version || null,
    () => null,
  )
  return cached
}

/** Solo para tests: olvida la versión cacheada. */
export function resetAppVersionForTests(): void {
  cached = null
}
